module.exports = __webpack_public_path__ + "img/InnovationScreenBig.0f5505a1.jpg";